<form [formGroup]="form.formGroup">
  <p-panel>
    <ng-template pTemplate="header">
      <div class="flex flex-col items-center m-2 w-full">
        <label class="flex-shrink-0">Temperature</label>
        <p-select
          [disabled]="isReadOnly"
          [options]="temps"
          [formControlName]="form.formControlNames.type"
          appendTo="body"
        ></p-select>
      </div>
    </ng-template>

    <div class="bg-[var(--p-content-background)] p-2">
      @switch (form.formGroup.value.type) {
        @case (TemperatureProfileType.BHCT) {
          <app-bhct-temp-profile
            [formControlName]="form.formControlNames.bhctTempProfile"
            [currentString]="currentString"
            [loadName]="loadName"
            [userUnits]="userUnits"
            [tubulars]="tubulars"
          ></app-bhct-temp-profile>
        }
        @case (TemperatureProfileType.THERMALLINK) {
          <app-perical-link-temp-profile
            [isReadOnly]="isReadOnly"
            [formControlName]="form.formControlNames.pericalLinkTempProfile"
            [thermalOperations]="thermalOperations"
            [userUnits]="userUnits"
          ></app-perical-link-temp-profile>
        }
        @case (TemperatureProfileType.UNDISTURBED) {
          <app-undisturbed-temp-profile
            [formControlName]="form.formControlNames.undisturbedTempProfile"
          ></app-undisturbed-temp-profile>
        }
        @case (TemperatureProfileType.CUSTOMTEMP) {
          <app-custom-temp-profile
            [formControlName]="form.formControlNames.customTempProfile"
            [wellType]="wellType"
            [currentString]="currentString"
            [userUnits]="userUnits"
            [wellTd]="wellTd"
          ></app-custom-temp-profile>
        }
      }
    </div>

  </p-panel>
</form>
